<template>
  <path
    d="M13.35 20.1302C12.59 20.8202 11.42 20.8202 10.66 20.1202L10.55 20.0202C5.30003 15.2702 1.87003 12.1602 2.00003 8.2802C2.06003 6.5802 2.93003 4.9502 4.34003 3.9902C6.98003 2.1902 10.24 3.0302 12 5.0902C13.76 3.0302 17.02 2.1802 19.66 3.9902C21.07 4.9502 21.94 6.5802 22 8.2802C22.14 12.1602 18.7 15.2702 13.45 20.0402L13.35 20.1302Z"
  />
</template>
